import { render, staticRenderFns } from "./CarfaxVehicleComparison.vue?vue&type=template&id=c2b405f4&scoped=true"
import script from "./CarfaxVehicleComparison.vue?vue&type=script&lang=js"
export * from "./CarfaxVehicleComparison.vue?vue&type=script&lang=js"
import "./CarfaxVehicleComparison.vue?vue&type=style&index=0&id=c2b405f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b405f4",
  null
  
)

export default component.exports